import React, { FC } from 'react'

export type Props = {
  header: string | null
}

export const Header: FC<Props> = ({ header }) => {
  return <h1 className="Visualizer-header">{header}</h1>
}
